var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-compare',_vm._b({attrs:{"objs":_vm.items,"label-key":_vm.labelKey}},'h-compare',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }